// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.feedback-tools .post-form__section--underline::after {\n  background-color: #e9e9ee;\n}\n.feedback-tools .post-form__section--underline:last-child::after {\n  height: 0;\n}\n", ""]);
// Exports
module.exports = exports;
